const REWARDFUL_COOKIE_NAME = "iqautoapply_rewardful_id";
const COOKIE_DAYS = 60;

function isBrowser(): boolean {
  return typeof window !== "undefined" && typeof document !== "undefined";
}

function getCookie(name: string): string | null {
  if (!isBrowser()) return null;

  const value = document.cookie
    .split("; ")
    .find((row) => row.startsWith(`${name}=`))
    ?.split("=")[1];

  return value ? decodeURIComponent(value) : null;
}

function setCookie(name: string, value: string, days: number): void {
  if (!isBrowser()) return;

  const maxAge = days * 24 * 60 * 60;
  document.cookie = `${name}=${encodeURIComponent(value)}; Max-Age=${maxAge}; Path=/; SameSite=Lax`;
}

function getViaParam(): string | null {
  if (!isBrowser()) return null;

  const via = new URLSearchParams(window.location.search).get("via")?.trim();
  return via || null;
}

function getFromRewardfulGlobal(): string | null {
  if (!isBrowser()) return null;

  const rewardful = (window as Window & { Rewardful?: unknown }).Rewardful;

  if (typeof rewardful === "object" && rewardful !== null) {
    const referralId = (rewardful as { referral?: unknown }).referral;
    if (typeof referralId === "string" && referralId.trim()) {
      return referralId.trim();
    }

    const id = (rewardful as { id?: unknown }).id;
    if (typeof id === "string" && id.trim()) {
      return id.trim();
    }
  }

  return null;
}

function debugLog(message: string, extra?: unknown) {
  if (import.meta.env.DEV) {
    console.debug(`[rewardful] ${message}`, extra ?? "");
  }
}

export function getRewardfulId(): string | null {
  if (!isBrowser()) return null;

  const via = getViaParam();
  if (via) {
    setCookie(REWARDFUL_COOKIE_NAME, via, COOKIE_DAYS);
    debugLog("Captured via param", via);
    return via;
  }

  const fromCookie = getCookie(REWARDFUL_COOKIE_NAME);
  if (fromCookie) {
    return fromCookie;
  }

  const fromRewardful = getFromRewardfulGlobal();
  if (fromRewardful) {
    setCookie(REWARDFUL_COOKIE_NAME, fromRewardful, COOKIE_DAYS);
    debugLog("Captured Rewardful global referral", fromRewardful);
    return fromRewardful;
  }

  return null;
}
